module.exports = __webpack_public_path__ + "img/country-insights-map.c65f5130.jpg";